// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__4g-Uq","subheader":"ReorderModal_subheader__xLscB","listWrap":"ReorderModal_listWrap__2IRG0"};